import PropTypes from 'prop-types';
const SVGComponent =({ fill = '#FAFAFA', ...props })  => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <mask
      id="mask0_4029_3902"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={16}
      height={16}
    >
      <rect x={0.5} width={16} height={16} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_4029_3902)">
      <path
        d="M3.83333 14C3.46667 14 3.15278 13.8694 2.89167 13.6083C2.63056 13.3472 2.5 13.0333 2.5 12.6667V4.66667H11.8333V14H3.83333ZM3.83333 12H10.5L8.23333 9L6.5 11.3333L5.43333 9.9L3.83333 12ZM3.83333 3.33333H2.5C2.5 2.96667 2.63056 2.65278 2.89167 2.39167C3.15278 2.13056 3.46667 2 3.83333 2V3.33333ZM5.16667 3.33333V2H6.5V3.33333H5.16667ZM7.83333 3.33333V2H9.16667V3.33333H7.83333ZM10.5 3.33333V2H11.8333V3.33333H10.5ZM13.1667 3.33333V2C13.5333 2 13.8472 2.13056 14.1083 2.39167C14.3694 2.65278 14.5 2.96667 14.5 3.33333H13.1667ZM13.1667 12.6667H14.5C14.5 13.0333 14.3694 13.3472 14.1083 13.6083C13.8472 13.8694 13.5333 14 13.1667 14V12.6667ZM13.1667 11.3333V10H14.5V11.3333H13.1667ZM13.1667 8.66667V7.33333H14.5V8.66667H13.1667ZM13.1667 6V4.66667H14.5V6H13.1667Z"
        fill={fill}
      />
    </g>
  </svg>
);

SVGComponent.propTypes = {
  fill: PropTypes.string,
};


export default SVGComponent;
